import { Component } from '@angular/core';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { Pim, PimProductRelatedProductsComponent } from 'gung-standard';

@Component({
    selector: 'car-liner-pim-product-power-units',
    templateUrl: './car-liner-pim-product-power-units.component.html',
    styleUrls: ['./car-liner-pim-product-power-units.component.scss'],
    standalone: false
})
export class CarLinerPimProductPowerUnitsComponent extends PimProductRelatedProductsComponent {
  onRelatedProductSelect(event: NgbTypeaheadSelectItemEvent) {
    const pim = event.item as Pim;

    if (!this.pimProduct.extra.pim.powerUnits) {
      this.pimProduct.extra.pim.powerUnits = pim.id;
    } else {
      if (this.pimProduct.extra.pim.powerUnits.indexOf(pim.id) < 0) {
        this.pimProduct.extra.pim.powerUnits += ',' + pim.id;
      }
    }

    event.preventDefault();
    this.modelRelatedProduct = null;
  }

  removeRelatedProduct(id: string) {
    const allRelatedProducts = this.pimProduct.extra.pim.powerUnits.split(',');

    const indexToRemove = allRelatedProducts.findIndex(itemId => itemId === id);
    if (indexToRemove > -1) {
      allRelatedProducts.splice(indexToRemove, 1);
    }

    this.pimProduct.extra.pim.powerUnits = allRelatedProducts.join(',');
  }
}
